import React, { memo, useCallback, useEffect } from "react";
import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
import styles from "./ContactModal.module.css";

const ContactModal = memo(({ isOpen, onClose }) => {
  const { websiteSetting } = useSelector((state) => state.user);

  // Extract Line and Telegram URLs from websiteSetting
  const settings = Array.isArray(websiteSetting)
    ? websiteSetting[0]
    : websiteSetting?.data?.[0] || {};
  const lineUrl = settings?.lineUrl || "https://line.me/";
  const teleUrl = settings?.teleUrl || "https://telegram.org/";
  const dynamicChannels = Array.isArray(settings?.contactChannels)
    ? settings.contactChannels
    : [];

  const contactChannels =
    dynamicChannels.length > 0
      ? dynamicChannels
      : [
          {
            channelType: "line",
            contactName: "Line Official",
            contactUrl: lineUrl,
          },
          {
            channelType: "telegram",
            contactName: "Telegram",
            contactUrl: teleUrl,
          },
        ];

  const handleOverlayClick = useCallback(
    (e) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    },
    [onClose],
  );

  const handleEscapeKey = useCallback(
    (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, handleEscapeKey]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal} role="dialog" aria-modal="true" aria-labelledby="contact-title">
        <div className={styles.header}>
          <h2 id="contact-title" className={styles.title}>
            ช่องทางติดต่อ
          </h2>
          <button
            type="button"
            className={styles.close}
            onClick={onClose}
            aria-label="ปิด"
          >
            <Icon icon="solar:close-circle-linear" width={26} />
          </button>
        </div>

        <p className={styles.lead}>
          ทีมงานพร้อมดูแลคุณตลอด 24 ชั่วโมง เลือกช่องทางที่สะดวก
        </p>

        <div className={styles.list}>
          {contactChannels.map((channel, index) => {
            const isLine = channel.channelType === "line";
            const iconSrc = isLine
              ? "https://space.star69.co/line.webp"
              : "https://space.star69.co/telegram.webp";
            const itemTitle =
              channel.contactName || (isLine ? "LINE" : "Telegram");
            const itemDesc = isLine
              ? "แชทสดกับทีมงานผ่านไลน์"
              : "ส่งข้อความผ่านเทเลแกรม";

            return (
              <button
                type="button"
                key={`${channel.channelType}-${channel.contactUrl}-${index}`}
                className={styles.item}
                onClick={() => window.open(channel.contactUrl, "_blank")}
              >
                <img src={iconSrc} alt="" className={styles.itemIcon} />
                <span className={styles.itemText}>
                  <strong>{itemTitle}</strong>
                  <small>{itemDesc}</small>
                </span>
                <Icon icon="solar:alt-arrow-right-linear" width={20} />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
});

ContactModal.displayName = "ContactModal";

export default ContactModal;
